import { CircleAlert, PlugZap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

const State = ({ ok, children, testId }) => (
  <span className={`status-badge ${ok ? "ok" : "err"}`} data-testid={testId}>{children}</span>
);

export const AutoTradingControls = ({ data, busy, onConnectionCheck, onMasterChange }) => {
  const canEnable = data.credentials_configured && data.connection_confirmed && data.read_permission
    && data.trade_permission && data.demo_trading_confirmed && data.hedge_mode_compatible;
  return <>
    <div className="demo-guard" data-testid="demo-only-guard">
      <CircleAlert size={17} aria-hidden="true" />
      <div><strong>仅限 OKX Demo</strong><span>无实盘切换路径；总开关仅由管理员手动控制。</span></div>
    </div>
    <div className="control-band" data-testid="auto-trading-control-band">
      <div className="control-state">
        <span>Demo API</span>
        <State ok={data.credentials_configured} testId="demo-credentials-status">
          {data.credentials_configured ? "已配置" : "尚未配置"}
        </State>
      </div>
      <div className="control-state">
        <span>连接确认</span>
        <State ok={data.connection_confirmed} testId="demo-connection-status">
          {data.connection_confirmed ? "已确认" : "未确认"}
        </State>
      </div>
      <div className="control-state">
        <span>读取权限</span>
        <State ok={data.read_permission} testId="demo-read-permission-status">
          {data.read_permission ? "正常" : "未确认"}
        </State>
      </div>
      <div className="control-state">
        <span>交易权限</span>
        <State ok={data.trade_permission} testId="demo-trade-permission-status">
          {data.trade_permission ? "正常" : "未确认"}
        </State>
      </div>
      <div className="control-state">
        <span>Demo 确认</span>
        <State ok={data.demo_trading_confirmed} testId="demo-trading-confirmed-status">
          {data.demo_trading_confirmed ? "已确认" : "未确认"}
        </State>
      </div>
      <div className="control-state">
        <span>持仓模式</span>
        <State ok={data.hedge_mode_compatible} testId="demo-position-mode">
          {data.position_mode === "long_short_mode" ? "多空双向" : (data.position_mode || "待检查")}
        </State>
      </div>
      <div className="control-state grow">
        <span>USDT Equity</span>
        <b className="mono" data-testid="demo-usdt-equity">{data.usdt_equity || "—"}</b>
      </div>
      <Button variant="secondary" onClick={onConnectionCheck} disabled={busy || !data.credentials_configured}
        data-testid="check-demo-connection-button">
        <PlugZap aria-hidden="true" />检查并确认连接
      </Button>
      <label className="master-control" data-testid="master-switch-control">
        <span><b>自动执行总开关</b><small>{data.master_enabled ? "已开启" : "保持关闭"}</small></span>
        <Switch className="master-switch" checked={Boolean(data.master_enabled)}
          onCheckedChange={onMasterChange} disabled={busy || (!data.master_enabled && !canEnable)}
          aria-label="自动执行总开关" data-testid="auto-trading-master-switch" />
      </label>
    </div>
  </>;
};